/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import Manipulator from '../../../utils/dom/manipulator';
import Request from '../../../utils/request';

class YourCourses {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.js-your-courses-wrapper');
		if (!this._wrapper) return;

		this._coursesApiUrl = Manipulator.getDataAttribute(this._wrapper, 'courses-api-url');
		this._manageClassPageUrl = Manipulator.getDataAttribute(this._wrapper, 'manage-class-page-url');
		this._courseDetailsPageUrl = Manipulator.getDataAttribute(this._wrapper, 'course-details-page-url');
		this._coursesContainer = SelectorEngine.findOne('.js-your-courses-container');
		this._courses = {};

		this._fetchCourses();
	}

	_renderTitle() {
		const title = this._coursesContainer?.querySelector('.js-your-courses-title');
		const { totalPageSize } = this._courses;
		if (title) title.textContent = `Courses (${totalPageSize})`;
	}

	_renderFetchingState() {
		const body = this._coursesContainer?.querySelector('.js-your-courses-body');
		const status = this._coursesContainer?.querySelector('.js-your-courses-status');
		if (!body) return;
		body.innerHTML = '';
		status.innerText = 'Fetching courses...';
		status.hidden = false;
	}

	_renderCoursesRows() {
		const { courses } = this._courses;
		const body = this._coursesContainer?.querySelector('.js-your-courses-body');
		const status = this._coursesContainer?.querySelector('.js-your-courses-status');
		if (!body) return;
		if (!courses?.length) {
			body.innerHTML = '';
			status.innerText = 'No courses found';
			status.hidden = false;
			return;
		}
		status.hidden = true;
		this._renderTitle();
		body.innerHTML = courses
			.map(
				(c) => `
			<article class="u-border u-rounded u-mb-3" aria-label="${c.name || 'Course'}">
				<div class="u-flex u-justify-space-between u-align-start u-gap-2 u-p-2">
					<a href="${this._courseDetailsPageUrl}/?courseId=${c.courseId}" class="u-title-case2 u-text-tf-navy p-course-providers-your-courses__course-title-link">${c.name || ''}</a>
					<span class="lta-tag lta-tag--lta-blue xl:u-ml-4 sm:u-mb-2">${c.activeClassTotal || '0'} active courses</span>
				</div>
				<div class="u-p-2 u-border-top md:u-flex u-justify-space-between u-align-center u-text-center u-bg-background-grey">
					<p class="u-subtitle4 u-m-0"><span class="sr-only">Format: </span>${c.format || ''}</p>
					<p class="u-subtitle4 u-m-0"><span class="sr-only">Credits: </span>${c.creditsInfo || ''}</p>
					<p class="u-subtitle4 u-m-0"><span class="sr-only">Duration: </span>${c.duration || ''}</p>
					<a class="u-mt-3 md:u-mt-0 lta-btn lta-btn--sm lta-btn--line lta-btn--icon lta-btn--icon-before" href="${this._manageClassPageUrl}" aria-label="Add course for ${c.name || 'course'}">
						<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.5em" height="1.5em" style="color:currentColor;" fill="currentColor" aria-hidden="true"><use xlink:href="/static/images/icons/lta-icons.svg#plus"></use></svg>
						Add course
					</a>
				</div>
			</article>
		`
			)
			.join('');
	}

	async _fetchCourses() {
		try {
			this._renderFetchingState();
			const response = await Request.get(this._coursesApiUrl, {});
			const { courses, totalPageSize } = response.responseContainerContents;
			this._courses = { courses, totalPageSize: courses.length || 0  };
		} catch (error) {
			this._courses = { courses: [], totalPageSize: 0 };
		} finally {
			this._renderCoursesRows();
			document.dispatchEvent(new CustomEvent('notifications:ready-to-fetch'));
		}
	}
}

const globalYourCourses = new YourCourses();
export default globalYourCourses;
